import { API } from "@swivl-mono/api-helper";
import { FMSInterface, FMSType } from "@swivl-mono/types";
import { create } from "zustand";

import { Member } from "../Member/Member.Current";

interface StoreInterface {
  FMSs?: FMSInterface[];
  FMS?: FMSInterface;
  isLoading: boolean;
  isAddingFMS?: boolean;
  isSavingFMS?: boolean;
}
const BlankState: StoreInterface = {
  FMSs: undefined,
  FMS: undefined,
  isLoading: true,
  isAddingFMS: false,
  isSavingFMS: false
};
export default class FMSModel {
  static useState = create<StoreInterface>((set) => ({ ...BlankState }));
  static setState = FMSModel.useState.setState;
  static get state() {
    return FMSModel.useState.getState();
  }
  static reset() {
    FMSModel.setState({ ...BlankState });
  }

  static async load(force) {
    if (FMSModel.state.FMSs && !force) {
      return;
    }
    FMSModel.setState({ isLoading: true });
    let FMSs = await API.FMS.getFMSByOrgId(Member.orgId!);
    FMSModel.setState({ isLoading: false, FMSs: FMSs });
  }

  static async loadById(fmsId: number) {
    FMSModel.setState({ isLoading: true });
    let FMS = await API.FMS.getFMSById(Member.orgId!, fmsId);
    FMSModel.setState({ isLoading: false, FMS: FMS });
  }

  static async addFMS(type: FMSType) {
    let FMSs = FMSModel.state.FMSs || [];
    FMSModel.setState({ isAddingFMS: true });
    let name = String(type);
    let existing = FMSs?.filter((fms) => fms.type === type);
    if (existing.length > 0) {
      name = `${type} ${existing.length + 1}`;
    }

    const vars = {
      smallMaxSize: 50,
      mediumMaxSize: 150,
      largeMaxSize: 300,
      actionButton: "Reserve Now",
      sizeSmallDescription: "Similar in size to a walk-in closet. Holds the contents of a studio apartment.",
      sizeMediumDescription: "Similar in size to a small bedroom. Holds the contents of a typical garage.",
      sizeLargeDescription: "Similar in size to a 1 to 1.5 car garage. Holds the contents of a 3-4 bedroom house",
      sizeExtraLargeDescription: "You have a lot of stuff! These units have plenty of room for your whole house!",
      sizeParkingDescription: "Each spot varies, but sizing ranges from a small utility trailer, vehicle, or camper, to a large Class A / Motorhome.",
      showPrice: true,
      showFloor: true
    };
    const fms: Omit<FMSInterface, "id"> = {
      type: type,
      orgId: Member.orgId!,
      name: name,
      token: {},
      createdAt: new Date(),
      updatedAt: new Date(),
      data: vars,
      jitSettings: null
    };

    const updatedFMS = await API.FMS.createFMS(Member.orgId!, fms);
    FMSs.push(updatedFMS);
    FMSModel.setState({ isAddingFMS: false, FMSs: FMSs });
  }

  static async deleteFMS(fms: FMSInterface) {
    let FMSs = FMSModel.state.FMSs || [];
    let index = FMSs.findIndex((f) => f.id === fms.id);
    if (index >= 0) {
      FMSs.splice(index, 1);
      FMSModel.setState({ FMSs: FMSs });
    }
    API.FMS.deleteFMS(Member.orgId!, fms.id);
  }
  static async updateFMS(fms: FMSInterface, shouldSave: boolean, apiPayload?: Partial<FMSInterface>) {
    let FMSs = FMSModel.state.FMSs || [];
    let index = FMSs.findIndex((f) => f.id === fms.id);
    if (index >= 0) {
      FMSs[index] = fms;
      FMSModel.setState({ FMSs: FMSs });
    }
    if (shouldSave) {
      API.FMS.updateFMS(Member.orgId!, fms.id, apiPayload || { name: fms.name, data: fms.data });
    }
  }
}
